import { Injectable } from '@angular/core';

/**
 * Defines the available feature flags in the application.
 * Add new feature flags here to ensure TypeScript provides proper autocomplete and type safety.
 */
export type FeatureFlags =
  | 'featureSalesBattle'
  // TODO MSD-661: Remove after the Nettvern launch, together with the pre-launch info box it gates.
  | 'featureNettvernPrelaunch'
  // TODO MSD-662: Remove once Nettvern has been live for a while, keeping the post-launch behaviour.
  | 'featureNettvernPostlaunch'
  | 'featureMbbSubscriptionOnlyWithBinding'
  | 'featureMultipleExtraSims';

@Injectable({
  providedIn: 'root',
})
export class FeatureGateService {
  private features: Record<string, boolean> = {};

  constructor() {
    this.loadFeatures();
  }

  private loadFeatures(): void {
    if (window && (window as any).DIEGO_APP_DATA) {
      const config = (window as any).DIEGO_APP_DATA;

      this.features = {
        featureSalesBattle: config.featureSalesBattle === 'true',
        featureMbbSubscriptionOnlyWithBinding: config.featureMbbSubscriptionOnlyWithBinding === 'true',
        featureMultipleExtraSims: config.featureMultipleExtraSims === 'true',
        featureNettvernPrelaunch: config.featureNettvernPrelaunch === 'true',
        featureNettvernPostlaunch: config.featureNettvernPostlaunch === 'true',
      };
    }
  }

  /**
   * Checks if a given feature flag is enabled.
   *
   * @param feature - The feature flag to check.
   * @returns `true` if the feature is enabled, otherwise `false`.
   *
   * @example
   * ```typescript
   * if (featureGateService.isFeatureEnabled('featureSalesBattle')) {
   *   console.log('Sales battle feature is enabled!');
   * }
   * ```
   */
  isFeatureEnabled(feature: FeatureFlags): boolean {
    return this.features[feature] ?? false;
  }
}
